import api from "./api.ts";

export async function getProfile(userId: number | string) {
  const token = localStorage.getItem("token");
  return api.get(`/users/profile/${userId}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
}
